import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  fieldWrapper: {
    display: "block",
    "margin-bottom": "20px",
  },
  label: {
    display: "block",
    "margin-bottom": "10px",
  },
}));

export default useStyles;
